'use strict';
var twentyninetimes = twentyninetimes || {};

twentyninetimes.siteSliders = twentyninetimes.siteSliders || function () {

	function init() {
    let sliders = document.querySelectorAll('.js-slider');
    if ( sliders ) {
      sliders.forEach(slider => {
        if ( slider.hasAttribute('data-timeline-slider') ) {
          timelineSlider(slider);
        } else if ( slider.hasAttribute('data-card-slider') ) {
          cardSlider(slider);
        } else {
          mediaSlider(slider);
        }
      });
    }
	}

	function mediaSlider(slider) { 
    var buttonsToggle = slider.getAttribute('data-buttons-toggle');

    buttonsToggle = buttonsToggle == 'true' 
      ? true 
      : false;

    var flky = new Flickity( slider, {
			accessibility: true,
			wrapAround: true,
      initialIndex: 1,
      cellAlign: 'center',
			prevNextButtons: buttonsToggle,
			pageDots: false,
			adaptiveHeight: false,
			on: {
				ready: function() {
					this.resize();
				},
				change: function() {
            // remove classes
          changeSlideClasses( this.previousSlide, 'remove', 'is-previous' );
          changeSlideClasses( this.nextSlide, 'remove', 'is-next' );

          if (this.selectedIndex - 1 < 0) {
            this.previousSlide = this.slides[ this.slides.length - 1 ]
          }
          else {
            this.previousSlide = this.slides[ this.selectedIndex - 1 ]
          }
          if (this.selectedIndex + 1 === this.slides.length) {
            this.nextSlide = this.slides[0]
          }
          else {
            this.nextSlide = this.slides[this.selectedIndex + 1]
          }

          changeSlideClasses( this.previousSlide, 'add', 'is-previous' );
          changeSlideClasses( this.nextSlide, 'add', 'is-next' );

          if ( this.element.classList.contains('video-enabled') ) {
            var video = this.element.querySelector('.oembed.active');

            if ( video ) {
              video.classList.remove('active', 'has-media');
              
              var oembed_wrapper = video.querySelector('.oembed__inline-wrapper');
              video.removeChild(oembed_wrapper);
            }
          }
        }
			}
		});
	}

  function timelineSlider(slider) {
    var flky = new Flickity( slider, {
			accessibility: true,
			prevNextButtons: true,
      cellAlign: 'left',
      percentPosition: true,
			pageDots: false,
      contain: true,
			on: {
				ready: function() {
					this.resize();
				}
			}
		});
  }

  function cardSlider(slider) {
    var groupCells = window.innerWidth > 559 ? 2 : 1;
    var flky = new Flickity( slider, {
			accessibility: true,
			prevNextButtons: true,
      cellAlign: 'left',
      percentPosition: true,
			pageDots: false,
      contain: true,
      groupCells: groupCells,
			on: {
				ready: function() {
					this.resize();
				}
			}
		});
  }

  function changeSlideClasses( slide, method, className ) {
    if (!slide) {
      return
    }
    slide.getCellElements().forEach( function( cellElem ) {
      cellElem.classList[ method ]( className )
    })
  }

	return {
		init : init
	};

}();